import { render, staticRenderFns } from "./MailToSupport.vue?vue&type=template&id=4c307b76&scoped=true&"
import script from "./MailToSupport.vue?vue&type=script&lang=js&"
export * from "./MailToSupport.vue?vue&type=script&lang=js&"
import style0 from "./MailToSupport.vue?vue&type=style&index=0&id=4c307b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c307b76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c307b76')) {
      api.createRecord('4c307b76', component.options)
    } else {
      api.reload('4c307b76', component.options)
    }
    module.hot.accept("./MailToSupport.vue?vue&type=template&id=4c307b76&scoped=true&", function () {
      api.rerender('4c307b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Billings/MailToSupport.vue"
export default component.exports